import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import FloatingButton from "./FloatingButton";

import logo from "../assets/idlogo.png";

// SOCIAL ICONS
import fb from "../assets/fb.png";
import insta from "../assets/instag.png";
import linkedin from "../assets/link.png";
import youtube from "../assets/youtube.png";

// CONTACT ICONS
import phone from "../assets/call.png";
import email from "../assets/gmail.png";
import location from "../assets/map.png";
import whatsappIcon from "../assets/social.png";

const Footer = () => {
  const [emailSubscriber, setEmailSubscriber] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (emailSubscriber) {
      setIsSubscribed(true);
      setEmailSubscriber("");
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer-premium">
        {/* Animated Background */}
        <div className="footer-bg">
          <div className="footer-particles"></div>
        </div>

        <div className="footer-premium-container">
          {/* Top Section with Newsletter */}
          <div className="footer-top">
            <div className="newsletter-section">
              <div className="newsletter-content">
                <h3>Subscribe to Our Newsletter</h3>
                <p>Get the latest updates, investigation tips, and exclusive offers</p>
              </div>
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <div className="input-group">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={emailSubscriber}
                    onChange={(e) => setEmailSubscriber(e.target.value)}
                    required
                  />
                  <button type="submit">
                    Subscribe
                    <span className="btn-arrow">→</span>
                  </button>
                </div>
                {isSubscribed && (
                  <div className="subscribe-success">
                    ✓ Successfully subscribed!
                  </div>
                )}
              </form>
            </div>
          </div>

          {/* Main Footer Grid */}
          <div className="footer-main-grid">
            {/* Brand Column */}
            <div className="footer-col brand-col">
              <img src={logo} alt="Indian-Detective Agency" className="footer-premium-logo" />
              <p className="brand-description">
                India's most trusted detective agency providing confidential, reliable, 
                and result-oriented investigation services since 2016.
              </p>
              <div className="trust-badges">
                <div className="trust-badge">
                  <span className="badge-dot"></span>
                  ISO Certified
                </div>
                <div className="trust-badge">
                  <span className="badge-dot"></span>
                  Govt Licensed
                </div>
              </div>
              <div className="social-icons-premium">
                <a href="#" className="social-icon fb"><img src={fb} alt="facebook" /></a>
                <a href="#" className="social-icon insta"><img src={insta} alt="instagram" /></a>
                <a href="#" className="social-icon linkedin"><img src={linkedin} alt="linkedin" /></a>
                <a href="#" className="social-icon youtube"><img src={youtube} alt="youtube" /></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/services">Our Services</Link></li>
                <li><Link to="/branches">Our Branches</Link></li>
                <li><Link to="/insights">Insights</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>

            {/* Personal Investigation */}
            <div className="footer-col">
              <h4>Personal Investigation</h4>
              <ul>
                <li><Link to="/services/pre-marriage-verification">Pre-Marriage Verification</Link></li>
                <li><Link to="/services/cheating-spouse-investigation">Cheating Spouse Investigation</Link></li>
                <li><Link to="/services/divorce-evidence-collection">Divorce Evidence Collection</Link></li>
                <li><Link to="/services/missing-person-tracing">Missing Person Tracing</Link></li>
                <li><Link to="/services/digital-evidence-collection">Digital Evidence Collection</Link></li>
                <li><Link to="/services/loyalty-test">Loyalty Test</Link></li>
              </ul>
            </div>

            {/* Corporate Investigation */}
            <div className="footer-col">
              <h4>Corporate Investigation</h4>
              <ul>
                <li><Link to="/services/employee-verification">Employee Verification</Link></li>
                <li><Link to="/services/corporate-due-diligence">Corporate Due Diligence</Link></li>
                <li><Link to="/services/financial-fraud">Financial Fraud</Link></li>
                <li><Link to="/services/undercover-operations">Undercover Operations</Link></li>
                <li><Link to="/services/competitor-intelligence">Competitor Intelligence</Link></li>
                <li><Link to="/services/insider-threats">Insider Threats</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-col contact-col">
              <h4>Get In Touch</h4>
              <ul className="contact-list">
                <li>
                  <div className="contact-icon call">
                    <img src={phone} alt="phone" />
                  </div>
                  <div className="contact-details">
                    <span>Call Us 24/7</span>
                    <a href="tel:+917428203483">+91 7428203483</a>
                  </div>
                </li>
                <li>
                  <div className="contact-icon whatsapp">
                    <img src={whatsappIcon} alt="whatsapp" />
                  </div>
                  <div className="contact-details">
                    <span>WhatsApp</span>
                    <a href="https://wa.me/917428203483">+91 7428203483</a>
                  </div>
                </li>
                <li>
                  <div className="contact-icon email">
                    <img src={email} alt="email" />
                  </div>
                  <div className="contact-details">
                    <span>Email Us</span>
                    <a href="mailto:indiandetective23@gmail.com">indiandetective23@gmail.com</a>
                  </div>
                </li>
                <li>
                  <div className="contact-icon location">
                    <img src={location} alt="location" />
                  </div>
                  <div className="contact-details">
                    <span>Visit Us</span>
                    <p>H.NO-118, Rohini, North West Delhi - 110042</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="footer-bottom-premium">
            <div className="copyright">
              © 2016–{currentYear} <strong>Indian-Detective Agency</strong>. All rights reserved.
            </div>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Floating Buttons - Separate Component */}
      <FloatingButton />
    </>
  );
};

export default Footer;